import { RoutingFlags } from '@constants/routingFlags';

const TrackTraceRoute = {
  path: '/TrackTrace',
  load: () => import('./TrackTrace'),
  protected: true,
  routingFlag: RoutingFlags.TrackTrace,
};

export { TrackTraceRoute };
